export default "__VITE_ASSET__CCzPQ5Du__"